import { render } from "./KryptonPopinWrapper.vue?vue&type=template&id=e6639a4a&lang=pug"
import script from "./KryptonPopinWrapper.vue?vue&type=script&lang=js"
export * from "./KryptonPopinWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__